'use client';

import { Button } from '@common/components';

import { CustomLink } from '@/app/_components/CustomLink';
import { DONATION_ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';

import { PARTNERS_LINK_FORM_ID } from '../_utils/labels';
import { PartnersBlurOverlay } from './PartnersBlurOverlay';
import { PartnersLoginPanel } from './PartnersLoginPanel';

interface PartnersGateProps {
  isGuest: boolean;
  hasLinks: boolean;
  placeholder: React.ReactNode;
  children: React.ReactNode;
}

export const PartnersGate = ({
  isGuest,
  hasLinks,
  placeholder,
  children,
}: PartnersGateProps) => {
  const router = useCustomRouter();

  if (!isGuest && hasLinks) {
    return children;
  }

  return (
    <>
      <div inert className="select-none">
        {placeholder}
      </div>
      {isGuest ? (
        <PartnersLoginPanel
          onClose={() => router.back(DONATION_ROUTES.PARTNERS.pathname)}
        />
      ) : (
        <PartnersBlurOverlay
          title="파트너스 링크 등록이 먼저 필요해요"
          description="링크를 만들면 실적과 정산내역을 볼 수 있어요."
        >
          <div className="flex w-240 flex-col">
            <Button asChild dimensions="H48">
              <CustomLink
                href={`${DONATION_ROUTES.PARTNERS.pathname}#${PARTNERS_LINK_FORM_ID}`}
              >
                링크 만들기
              </CustomLink>
            </Button>
          </div>
        </PartnersBlurOverlay>
      )}
    </>
  );
};
